import { ComponentIds } from '@inter-ikea-core/core';
import { CoreApi, ProductType } from '@inter-ikea-storageone/range';

export const noShelfOrganizersInScene = (coreApi: CoreApi) => {
  const shelvesAndFrames = coreApi.entities.getByProductTypes([
    ProductType.PLATSA_SHELF,
    ProductType.PLATSA_FRAME,
    ProductType.PLATSA_OPEN_FRAME_SHELVES,
    ProductType.PLATSA_OPEN_FRAME_HANGING,
    ProductType.PLATSA_OPEN_FRAME_SHOES
  ]);
  const shelfOrganizers = shelvesAndFrames.flatMap(entity =>
    coreApi.entities.getChildrenWithOneOfProductTypes(entity, [
      ProductType.PLATSA_SHELF_ORGANIZER,
      ProductType.PLATSA_SHELF_AND_DRAWER_ORGANIZER
    ])
  );
  return shelfOrganizers.length === 0;
};

export const noDrawerOrganizersInScene = (coreApi: CoreApi) => {
  const drawers = coreApi.entities.getByComponent(ComponentIds.DRAWER_COMPONENT_ID);
  const drawerOrganizers = drawers.flatMap(drawer =>
    coreApi.entities.getDescendantsWithOneOfProductTypes(drawer, [
      ProductType.PLATSA_SHELF_AND_DRAWER_ORGANIZER
    ])
  );
  return drawerOrganizers.length === 0;
};
